// ประเภทของการประชุม (ต้องตรงกับ meetingType.js ของ backend)
// ใช้เลือกข้อความที่ผู้สแกน QR เห็น และหัวข้อวิธีสแกนบน QR
export const DEFAULT_TYPE = 'meeting';

export const MEETING_TYPES = [
  { value: 'meeting', label: 'การประชุม' },
  { value: 'registration', label: 'ลงทะเบียน' },
];

const QR_HEADLINES = {
  meeting: 'วิธีลงทะเบียนเข้าร่วมประชุม',
  registration: 'วิธีลงทะเบียน',
};

// ข้อความหน้าผู้สแกนเมื่อลงทะเบียนสำเร็จ
// (ระหว่างรอใช้ข้อความกลาง "กำลังลงทะเบียน..." เพราะยังไม่รู้ประเภทจนกว่า backend จะตอบ)
const JOIN_TEXTS = {
  meeting: {
    title: 'ลงทะเบียนเข้าร่วมประชุมสำเร็จ',
    // \n = ขึ้นบรรทัดใหม่ (หน้าผู้สแกนใช้ white-space: pre-line)
    welcome: name => (name ? `ยินดีต้อนรับ ${name}\nเข้าสู่การประชุม` : 'ยินดีต้อนรับเข้าสู่การประชุม'),
  },
  registration: {
    title: 'ลงทะเบียนสำเร็จ',
    welcome: name => (name ? `ขอบคุณที่ลงทะเบียน ${name}` : 'ขอบคุณที่ลงทะเบียน'),
  },
};

export function typeOf(value) {
  return MEETING_TYPES.some(t => t.value === value) ? value : DEFAULT_TYPE;
}

export function qrHeadline(type) {
  return QR_HEADLINES[typeOf(type)];
}

export function joinTexts(type) {
  return JOIN_TEXTS[typeOf(type)];
}
